import { GlobalStyles, ThemeProvider } from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import adapterLocalePTBR from "date-fns/locale/pt-BR";
import { ptBR } from "@mui/x-date-pickers/locales";

import Router from "./router";
import { GLOBAL_STYLES, THEME } from "./styles/theme";
import { NotificationProvider } from "./contexts";

function App() {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocalePTBR}
      localeText={
        ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <ThemeProvider theme={THEME}>
        <GlobalStyles styles={GLOBAL_STYLES} />
        <NotificationProvider>
          <Router />
        </NotificationProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
